export default __webpack_public_path__ + "static/dot-pattern-b213873315535e71d5a81ed69505c47c.svg";